package com.milta.feature.team.domain.entity

/** MIL-53 — read-only Organisation profile (Dashboard Web "Paramètres"). Renaming is out of MVP,
 * so name is the only field exposed today. */
data class Enterprise(
    val id: String,
    val name: String,
)
